import React, { useMemo, useCallback } from 'react';
import { Label } from '../input-text/input.styled';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { QuillEditorContainer } from './richTextEditor.styled';

interface RichTextType {
  name: string;
  setFieldValue: (name: string, value: string) => void;
  value: string;
  error?: any;
  touched?: any;
  initialContentState?: any;
  label?: string;
  placeholder?: string;
  readOnly?: boolean;
}

const QuillRichTextEditor = ({
  name,
  setFieldValue,
  value,
  error,
  touched,
  label,
  placeholder,
  readOnly,
}: RichTextType): JSX.Element => {
  // Memoize modules to prevent recreation on every render
  const modules = useMemo(
    () => ({
      toolbar: [
        ['bold', 'italic', 'underline'],
        [{ list: 'ordered' }, { list: 'bullet' }],
      ],
    }),
    []
  );

  // Memoize formats to prevent recreation on every render
  const formats = useMemo(() => ['bold', 'italic', 'underline', 'list', 'bullet'], []);

  // Memoize handleChange to prevent unnecessary re-renders
  const handleChange = useCallback(
    (content: string): void => {
      setFieldValue(name, content);
    },
    [name, setFieldValue]
  );

  if (readOnly) {
    return (
      <QuillEditorContainer>
        <div className='col-span-12'>
          <Label>Description (Optional)</Label>
          <div
            dangerouslySetInnerHTML={{ __html: value }}
            className={`border p-2 text-2xl rounded-lg bg-[#F3F3F3] descriptionOutput`}
          />
        </div>
      </QuillEditorContainer>
    );
  }

  return (
    <div>
      <QuillEditorContainer>
        <Label>{label || 'Description'}</Label>
        <div
          className={`${Boolean(error) && Boolean(touched) ? 'border border-red-700' : 'border'
            } rounded`}>
          <ReactQuill
            value={value || ''}
            onChange={handleChange}
            modules={modules}
            formats={formats}
            placeholder={placeholder}
            preserveWhitespace
          />
        </div>
      </QuillEditorContainer>
    </div>
  );
};

export default QuillRichTextEditor;
